import dayjs from "dayjs";
export const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");
export const getDatesInMonth = (initialDate) => {
    const month = initialDate.getMonth();
    const year = initialDate.getFullYear();
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
        days.push(formatDate(new Date(date)));
        date.setDate(date.getDate() + 1);
    }
    return days;
};
export const generateRange = (dates) => {
    if (dates.length < 2) {
        return dates;
    }
    const [startDate, endDate] = dates;
    const diff = dayjs(endDate).diff(startDate, "day");
    if (diff < 2) {
        return dates;
    }
    const rangeDates = [startDate];
    for (let i = 1; i < diff; i++) {
        rangeDates.push(dayjs(startDate).add(i, "day").toDate());
    }
    rangeDates.push(endDate);
    return rangeDates;
};
//# sourceMappingURL=helper.js.map